import styled from 'styled-components'

export const ComponentContainerStyled = styled.div`
  // color: ${({ theme }) => theme.COLORS.RED_1};
  .layout_1 {

  }
`
